/* eslint-disable no-console */
import { AxiosInstance } from 'axios'
import { BaseHTTP } from './base.http'
import { PlanCuentas } from '../models/planCuentas'

export class TablesAPI {

  private http !: AxiosInstance

  constructor() {
    this.http = BaseHTTP.getInstance().http
  }

  getDataHistoricalSales(params) {
    const path = `v1/business/${params}/resume`
    return this.http.get(path)
  }

  getDataBalance(businessId: number, queryFrom: string, queryTo: string) {
    const encodedQueryFrom = encodeURIComponent(queryFrom)
    const encodedQueryTo = encodeURIComponent(queryTo)
    const path = `v1/business/${businessId}/balance?queryFrom=${encodedQueryFrom}&queryTo=${encodedQueryTo}`
    return this.http.get(path)
  }

  patchApproveAll(businessId, payload){
    const path = `v1/business/${businessId}/approve-all`
    return this.http.patch(path, payload)
  }
  
  // getCuentaContable(queryParams) {
  //   const path = 'https://luca-api-dev-cbs8qj1d.ue.gateway.dev/v1/cuenta-contable/'
  //   return this.http.get(path, {
  //     params: queryParams,
  //     transformResponse: res => res, // Desactiva transformaciones
  //   })
  // }
  async getCuentaContable(businessId: number): Promise<PlanCuentas[]> {
    const path = `/v1/custom_cuenta/business/${businessId}/all-with-cuenta-contable`;
    try {
      const response = await this.http.get<{ success: boolean; data: PlanCuentas[] }>(path);
      if (response.data.success) {
        return response.data.data; // Retorna la lista de cuentas contables
      }
      throw new Error('Error al obtener los datos del plan de cuentas desde la API.');
    } catch (error) {
      console.error('Error al obtener el plan de cuentas desde la API:', error);
      throw error;
    }
  }
  
  // Si necesitas agregar un POST, este sería el formato:
  createCuentaContable(data) {
    const path = `v1/cuenta-contable/`
    return this.http.post(path, data)
  }

  postPresupuesto(businessId, payload) {
    const path = `v1/business/${businessId}/presupuesto`
    return this.http.post(path, payload)
  }

  getPresupuesto(businessId: number, params: { type: string; year: number }) {
    const { type, year } = params
    const path = `v1/business/${businessId}/presupuesto?type=${type}&year=${year}`
    return this.http.get(path)
  }
}

export default new TablesAPI()